export default [
  {
      path: '/',
      name: 'starter',
      component: () =>
          import('@/view/dashboard'),
  },
  {
      path: '/applications',
      name: 'applications',
      component: () =>
          import('@/view/application/Index.vue'),
      children: [
          {
              path: 'list',
              name: 'app-list',
              component: () =>
                  import('@/view/application/List.vue'),
          },
          {
              path: 'detail/:id',
              name: 'app-detail',
              component: () =>
                  import('@/view/application/detail/Detail.vue'),
              children: [
                  {
                      path: 'general',
                      name: 'detail-general',
                      component: () =>
                          import('@/view/application/detail/General.vue'),
                  },
                  {
                      path: 'price',
                      name: 'detail-price',
                      component: () =>
                          import('@/view/application/detail/Price.vue'),
                  },
                  {
                      path: 'modules-tracking',
                      name: 'detail-module-tracking',
                      component: () =>
                          import('@/view/application/detail/modules/trackingcode/List.vue'),
                  },
                  {
                      path: 'modules-tracking-new',
                      name: 'detail-module-tracking-new',
                      component: () =>
                          import('@/view/application/detail/modules/trackingcode/New.vue'),
                  },
                  {
                      path: 'modules-tracking-edit/:tracking_id',
                      name: 'detail-module-tracking-edit',
                      component: () =>
                          import('@/view/application/detail/modules/trackingcode/Edit.vue'),
                  },
                  {
                      path: 'modules-tracking',
                      name: 'detail-module-tracking',
                      component: () =>
                          import('@/view/application/detail/modules/trackingcode/List.vue'),
                  },
                  {
                      path: 'modules-htmlblock',
                      name: 'detail-module-htmlblock',
                      component: () =>
                          import('@/view/application/detail/modules/htmlblock/List.vue'),
                  },
                  {
                      path: 'modules-htmlblock-new',
                      name: 'detail-module-htmlblock-new',
                      component: () =>
                          import('@/view/application/detail/modules/htmlblock/New.vue'),
                  },
                  {
                      path: 'modules-htmlblock-edit/:htmlblock_id',
                      name: 'detail-module-htmlblock-edit',
                      component: () =>
                          import('@/view/application/detail/modules/htmlblock/Edit.vue'),
                  },
                  {
                      path: 'modules-webservice',
                      name: 'detail-module-webservice',
                      component: () =>
                          import('@/view/application/detail/modules/webservice/List.vue'),
                  },
                  {
                      path: 'modules-setting',
                      name: 'detail-module-setting',
                      component: () =>
                          import('@/view/application/detail/modules/setting/List.vue'),
                  },
                  {
                      path: 'modules-setting-new',
                      name: 'detail-module-setting-new',
                      component: () =>
                          import('@/view/application/detail/modules/setting/New.vue'),
                  },
                  {
                      path: 'modules-setting-edit/:setting_id',
                      name: 'detail-module-setting-edit',
                      component: () =>
                          import('@/view/application/detail/modules/setting/Edit.vue'),
                  },
                  {
                      path: 'modules-widget',
                      name: 'detail-module-widget',
                      component: () =>
                          import('@/view/application/detail/modules/widget/List.vue'),
                  },
                  {
                      path: 'modules-widget-new',
                      name: 'detail-module-widget-new',
                      component: () =>
                          import('@/view/application/detail/modules/widget/New.vue'),
                  },
                  {
                      path: 'modules-widget-edit/:widget_id',
                      name: 'detail-module-widget-edit',
                      component: () =>
                          import('@/view/application/detail/modules/widget/Edit.vue'),
                  },
                  {
                      path: 'package',
                      name: 'detail-package',
                      component: () =>
                          import('@/view/application/detail/Package.vue'),
                  },
                  {
                      path: 'inputs',
                      name: 'detail-inputs',
                      component: () =>
                          import('@/view/application/detail/Inputs/List.vue'),
                  },
                  {
                      path: 'inputs-new',
                      name: 'detail-inputs-new',
                      component: () =>
                          import('@/view/application/detail/Inputs/New.vue'),
                  },
                  {
                      path: 'inputs-edit/:input_id',
                      name: 'detail-inputs-edit',
                      component: () =>
                          import('@/view/application/detail/Inputs/Edit.vue'),
                  },
                  {
                      path: 'other',
                      name: 'detail-other',
                      component: () =>
                          import('@/view/application/detail/Other.vue'),
                  },
                  {
                      path: 'seo',
                      name: 'detail-seo',
                      component: () =>
                          import('@/view/application/detail/Seo.vue'),
                  },
                  {
                      path: 'release-notes',
                      name: 'detail-release-notes',
                      component: () =>
                          import('@/view/application/detail/ReleaseNotes.vue'),
                  },
                  {
                      path: 'images',
                      name: 'detail-images',
                      component: () =>
                          import('@/view/application/detail/Images.vue'),
                  },
                  {
                      path: 'review',
                      name: 'detail-review',
                      component: () =>
                          import('@/view/application/detail/Review.vue'),
                  },
              ],
          },
          {
              path: 'new/general',
              name: 'new-general',
              component: () =>
                  import('@/view/application/new/General.vue'),
          },
      ],
  },
  {
      path: '/orders',
      name: 'orders',
      component: () =>
          import('@/view/orders/Index.vue'),
      children: [
          {
              path: 'list',
              name: 'order-list',
              component: () =>
                  import('@/view/orders/Orders.vue'),
          },
          {
              path: 'detail/:id',
              name: 'order-detail',
              component: () =>
                  import('@/view/orders/Detail.vue'),
          }
      ]
  },
  {
      path: '/users',
      name: 'users',
      component: () =>
          import('@/components/users/List.vue'),
  },
  {
      path: '/sales',
      name: 'sales',
      component: () =>
          import('@/view/sales/Index.vue'),
  },
  {
      path: '/profile',
      name: 'profile',
      component: () =>
          import('@/view/profile/Index.vue'),
  },
  {
      path: '/domains',
      name: 'domains',
      component: () =>
      import('@/view/domains/list')
  },
  {
      path: '/settings',
      name: 'settings',
      component: () =>
          import('@/view/settings/Settings.vue'),
      children: [
          {
              path: 'profile-settings',
              name: 'profile-settings',
              component: () =>
                  import('@/view/settings/overview/Profile.vue'),
          },
          {
              path: 'profile-settings/profile',
              name: 'set-profile',
              component: () =>
                  import('@/view/settings/overview/Profile.vue'),
          },
          {
              path: 'profile-settings/account',
              name: 'set-account',
              component: () =>
                  import('@/view/settings/overview/Account.vue'),
          },
          {
              path: 'profile-settings/password',
              name: 'set-password',
              component: () =>
                  import('@/view/settings/overview/Password.vue'),
          },
          {
              path: 'profile-settings/invoice',
              name: 'set-invoice',
              component: () =>
                  import('@/view/settings/overview/Invoice.vue'),
          }, 
      ],
  },
  {
      path: '/coupon-codes',
      name: 'coupon-codes',
      component: () =>
          import('@/view/couponCodes/Index.vue'),
  },
  {
      path: '/statistics',
      name: 'statistics',
      component: () =>
          import('@/view/statistics/Statistics.vue'),
      children: [
          {
              path: 'developer',
              name: 'statistics-developer',
              component: () =>
                  import('@/view/statistics/overview/Developer.vue'),
          },
          {
              path: 'app',
              name: 'statistics-app',
              component: () =>
                  import('@/view/statistics/overview/App.vue'),
          },
          {
              path: 'sale',
              name: 'statistics-sale',
              component: () =>
                  import('@/view/statistics/overview/Sale.vue'),
          },
          {
              path: 'customer',
              name: 'statistics-customer',
              component: () =>
                  import('@/view/statistics/overview/Customer.vue'),
          },
          
      ]
  },
  {
      path: '/app-comments',
      name: 'app-comments',
      component: () =>
          import('@/view/appComments/Index.vue'),
  },
  {
      path: '/installs',
      name: 'installs',
      component: () =>
          import('@/view/installs/Index.vue')
  },
  {
    path: '/tasks',
    name: 'tasks',
    component: () => import('@/view/tasks/Index.vue'),
  },
  {
    path: '/developers',
    name: 'developers',
    component: () => import('@/view/developers/Index.vue'),
    children: [
        {
            path: 'list',
            name: 'developer-list',
            component: () =>
                import('@/view/developers/List.vue'),
        },
        {
            path: 'detail/:id',
            name: 'developer-detail',
            component: () =>
                import('@/view/developers/Detail.vue'),
        }
    ]
  },
  {
    path: '/tickets',
    name: 'tickets',
    component: () => import('@/view/tickets/Index.vue'),
    children: [
        {
            path: '',
            name: 'request-list',
            component: () =>
                import('@/view/tickets/List.vue'),
        },
        {
            path: 'detail/:id',
            name: 'request-detail',
            component: () =>
                import('@/view/tickets/Detail.vue'),
        },
        {
            path: 'create',
            name: 'request-create',
            component: () =>
                import('@/view/tickets/Create.vue'),
        },
        
    ]
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/view/notifications/Index.vue'),
  },
  {
    path: '/application-usage',
    name: 'application-usage',
    component: () => import('@/view/applicationUsage/Index.vue'),
  },
  {
    path: '/demos',
    name: 'demos',
    component: () => import('@/view/demos/Index.vue'),
    children: [
        {
            path: '',
            name: 'demos-list',
            component: () =>
                import('@/view/demos/List.vue'),
        },
        {
            path: 'detail/:id',
            name: 'demos-detail',
            component: () =>
                import('@/view/demos/Detail.vue'),
        },
    ]
  },
  {
    path: '/banners',
    name: 'banners',
    component: () => import('@/view/banners/Index.vue'),
    children: [
        {
            path: '',
            name: 'banners-list',
            component: () =>
                import('@/view/banners/List.vue'),
        },
        {
            path: 'detail/:id',
            name: 'banners-detail',
            component: () =>
                import('@/view/banners/Detail.vue'),
        },
        {
            path: 'create',
            name: 'banners-create',
            component: () =>
                import('@/view/banners/Create.vue'),
        },
    ]
  },
  {
    path: '/dev-permissions',
    name: 'dev-permissions',
    component: () => import('@/view/devPermissions/index.vue'),
    children: [
      {
        path: '',
        name: 'dev-permissions-list',
        component: () => import('@/view/devPermissions/list.vue'),
      },
      {
        path: 'detail/:id',
        name: 'dev-permissions-detail',
        component: () => import('@/view/devPermissions/detail.vue'),
      },
      {
        path: 'menus/:id',
        name: 'dev-permissions-menus',
        component: () => import('@/view/devPermissions/menus.vue'),
      },
    ],
  },
  {
    path: '/menus',
    name: 'menus',
    component: () => import('@/view/menus/index.vue'),
    children: [
      {
        path: '',
        name: 'menus-list',
        component: () => import('@/view/menus/list.vue'),
      },
      {
        path: 'detail/:id',
        name: 'menus-detail',
        component: () => import('@/view/menus/detail.vue'),
      },
    ],
  },
  {
    path: '/application-category',
    name: 'application-category',
    component: () => import('@/view/applicationCategory/Index.vue'),
  }

];